//
import UserModel  from '@/models/General/GUser'
import AccountingSeatModel  from '@/models/Accounting/AccAccountingSeat'

//
export default [
	{
		name: 'g_user_id',
		type: 'autocomplete-model',
		props: {
			itemText: 'hr_employee_full_name',
			itemValue: 'id',
			model: UserModel,
			label: 'Responsable',
			noObject: true,
		},
	},
	{
		name: 'acc_accounting_seat_id',
		type: 'autocomplete-model',
		props: {
			itemText: 'comment',
			itemValue: 'id',
			model: AccountingSeatModel,
			label: 'Asiento',
			noObject: true,
			paramSearch: 'comment',
		},
	},
	{
		name: 'matched',
		type: 'select',
		props: {
			clearable: true,
			items: [
				{
					text: 'Si',
					value: true,
				},
				{
					text: 'No',
					value: false,
				},
			],
			label: 'Conciliado'
		},
	},
]